<!-- src/components/MaintenancePage.vue -->
<template>
  <div class="maintenance-page">
    <img class="maintenance-image" src="../assets/images/under_maintenance.png" alt="Under Maintenance" />
    <h1>We're currently undergoing maintenance</h1>
    <p>Sorry for the inconvenience, we're performing some updates. Please check back later.</p>
  </div>
</template>

<script>
export default {
  name: "MaintenancePage",
};
</script>

<style scoped>
.maintenance-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
  text-align: center;
  background-color: #f4f4f9; /* Light background color */
  padding: 20px;
}

.maintenance-image {
  width: 1000px; /* Adjust image size */
  max-width: 100%;
  margin-bottom: 20px;
}

h1 {
  font-size: 2em;
  margin-bottom: 10px;
}

p {
  font-size: 1.2em;
  color: #666;
}
</style>
